const About = () => {
    return (
        <main>
            <h2 className="blue_background">ABOUT</h2>
            <section className="light_violet_background">
                <p>
                    Shade Corp started with a small team and steadily grew into a world wide
                    industry leader.
                </p>
                <p>
                    At Shade Corp we produce our own sails using the latest technology. This has
                    allowed us to develop the sails to a quality that is now used by many other
                    industries.
                </p>
                <p>
                    Our sails provide excellent protection against the sun and is aesthetically
                    pleasing while also being durable and long lasting. The Shade Corp team is
                    experienced professionals that is dedicated to excellent customer service
                    through the whole process.
                </p>
                <p>
                    Our sails can be customized to fit any design requirements and is available in a
                    wide range of colors, sizes and shapes.
                </p>
                <p>
                    Whether you want shade for your home, business or community space, we have the
                    expertise and resources to meet your needs.
                </p>
                <p>
                    We are very proud at what we have accomplished and is always striving to
                    improve.
                </p>
            </section>
            <h3 className="centered_elements light_blue_background">
                Creator profile:
                <br />
                <a href="https://cjsnyman.netlify.app">Craig Snyman</a>
            </h3>
        </main>
    );
};

export default About;
